import { useResource } from '@landsbankinn/l16n';
import { Col } from '@landsbankinn/ui-kit';
import { useScreenSize } from 'src/hooks/useScreenSize';
import { res } from './Consent.res';
import {
  ListView,
  MobileTitleAndDescription,
  ScopeDataView,
  SelectableListView,
} from './Shared';
import { useConsentClientContext } from './State/consentClientState';
import { getLocalizedString } from './utils';

export function DataView() {
  const { isMobile } = useScreenSize();
  const { r } = useResource();
  const [consentClient, consentDispatch] = useConsentClientContext();

  const view = consentClient.views[consentClient.currentViewIndex];
  let title = undefined;
  let description = undefined;

  if (view) {
    const isLastView =
      consentClient.currentViewIndex === consentClient.views.length - 1;
    // const hasPrevious = consentClient.currentViewIndex > 0;
    const hasNext =
      consentClient.currentViewIndex < consentClient.views.length - 1;

    let prevTitle = r(res.cancel);
    let nextTitle = r(res.confirm);

    if (consentClient.localization) {
      title = getLocalizedString('title', consentClient.localization);
      description = getLocalizedString(
        'description',
        consentClient.localization,
      );

      const rejectTitle = getLocalizedString(
        'reject_action',
        consentClient.localization,
      );
      prevTitle = rejectTitle ? rejectTitle : prevTitle;

      // if (hasPrevious) {
      //   prevTitle = r(res.back);
      // }

      if (hasNext) {
        const updateTitle = getLocalizedString(
          'update_action',
          consentClient.localization,
        );
        nextTitle = updateTitle ? updateTitle : r(res.continue);
      }
      if (isLastView) {
        const consentTitle = getLocalizedString(
          'consent_action',
          consentClient.localization,
        );
        nextTitle = consentTitle ? consentTitle : nextTitle;
      }
    }
    const showMobileTitle = isMobile && isLastView;

    switch (view.type) {
      case 'listviewselect':
        return (
          <Col grow="1">
            <SelectableListView
              data={view.data[0]}
              title={title}
              description={description}
              previousTitle={prevTitle}
              nextTitle={nextTitle}
              isLastView={isLastView}
              onNext={() => {
                consentDispatch({ type: 'update and next view' });
              }}
              onPrevious={() => {
                consentDispatch({ type: 'previous view' });
              }}
            />
          </Col>
        );
      case 'listview':
        return (
          <Col grow="1">
            {showMobileTitle && title && (
              <MobileTitleAndDescription
                title={title}
                description={description}
              />
            )}
            <ListView
              data={view.data[0]}
              title={title}
              description={description}
              previousTitle={prevTitle}
              nextTitle={nextTitle}
              isLastView={isLastView}
              onNext={() => {
                consentDispatch({ type: 'next view' });
              }}
              onPrevious={() => {
                consentDispatch({ type: 'previous view' });
              }}
            />
          </Col>
        );
      case 'view':
        return (
          <ScopeDataView
            data={view.data}
            previousTitle={prevTitle}
            nextTitle={nextTitle}
            isLastView={isLastView}
            onNext={() => {
              consentDispatch({ type: 'next view' });
            }}
            onPrevious={() => {
              consentDispatch({ type: 'previous view' });
            }}
          />
        );
    }
  }
  return null;
}
